import React from "react";
import {useNavigate} from "react-router-dom";
import {Header, StyledButton, StyledCard, Subtext,} from "./CheckYourMailbox.styled";
import {AuthContainer} from "./Auth.styled";
import Logo from "../../assets/images/taia_logo.png";
import {usePageTitle} from '../../hooks/usePageTitle';
import {PageTitleKeys} from '../../config/routeConstants';
import {useTranslation} from 'react-i18next';
import LogoWithLanguageSwitcher from '../../components/common/LogoWithLanguageSwitcher';

const CheckYourInbox: React.FC = () => {
    usePageTitle(PageTitleKeys.CheckMailbox);
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <AuthContainer role="region" aria-labelledby="check-mailbox-title">
            <LogoWithLanguageSwitcher src={Logo} alt={t('auth.logo.alt')} clickable={false} />
            <StyledCard>
            <Header id="check-mailbox-title">{t('checkMailbox.title')}</Header>
            <Subtext>{t('checkMailbox.subtitle')}</Subtext>
            <StyledButton onClick={() => navigate("/login")} aria-label={t('checkMailbox.backButton.ariaLabel') as string}>
                {t('checkMailbox.backButton')}
            </StyledButton>
        </StyledCard>
        </AuthContainer>
    );
};

export default CheckYourInbox;
